/* Lyndo cart drawer — reserveringstimer + versandschutz-schakelaar (zie snippets/cart-drawer.liquid) */
(function () {
  'use strict';
  if (window.__lyndoCart) return;
  window.__lyndoCart = true;

  /* Timer: 10 minuten, per sessie; begint opnieuw als hij afloopt */
  var KEY = 'lyndo_cart_timer_end';
  function endTime() {
    var end = 0;
    try { end = parseInt(sessionStorage.getItem(KEY), 10) || 0; } catch (e) {}
    if (!end || end < Date.now()) {
      end = Date.now() + 10 * 60 * 1000;
      try { sessionStorage.setItem(KEY, String(end)); } catch (e) {}
    }
    return end;
  }
  function tick() {
    var els = document.querySelectorAll('[data-lc-timer]');
    if (!els.length) return;
    var left = Math.max(0, Math.round((endTime() - Date.now()) / 1000));
    var txt = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
    els.forEach(function (el) { el.textContent = txt; });
  }
  tick();
  setInterval(tick, 1000);

  /* Drawer opnieuw renderen na een wijziging buiten cart.js om */
  function refresh() {
    var drawer = document.querySelector('cart-drawer');
    return fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parse = function (html, sel) { return new DOMParser().parseFromString(html, 'text/html').querySelector(sel); };
        if (drawer && sections['cart-drawer']) {
          var fresh = parse(sections['cart-drawer'], '#CartDrawer');
          var cur = document.getElementById('CartDrawer');
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
          var overlay = document.getElementById('CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
          drawer.classList.toggle('is-empty', !!document.querySelector('#CartDrawer .drawer__inner-empty'));
        }
        if (sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          var fb = parse(sections['cart-icon-bubble'], '.shopify-section');
          if (bubble && fb) bubble.innerHTML = fb.innerHTML;
        }
        tick();
      });
  }

  document.addEventListener('change', function (e) {
    var input = e.target && e.target.matches && e.target.matches('[data-lc-protect]') ? e.target : null;
    if (!input) return;
    var label = input.closest('.lc-switch');
    if (label) label.classList.add('is-busy');
    var root = window.Shopify.routes.root;
    var req = input.checked
      ? fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: input.getAttribute('data-variant'), quantity: 1 }] }) })
      : fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: input.getAttribute('data-key'), quantity: 0 }) });
    req.then(refresh).catch(function () { input.checked = !input.checked; if (label) label.classList.remove('is-busy'); });
  });
})();
